import React from 'react';
import { ChartFieldSection } from 'Components/Layout';
import { useSelector } from 'react-redux';
import deepEquals from 'Lib/Object/deepEquals';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { createMessagesGetter } from '../Helpers/messageHelpers';
import { pipe } from 'Lib/Hooks/Selectors';

interface IWorksheetChartSection extends IWorksheetComponent {
  visible?: boolean;
  wide?: boolean;
  height?: number;
}

let WorksheetChartSection: React.FC<IWorksheetChartSection> = ({
  visible = true,
  createWorksheetSelector,
  wide = false,
  height = 600,
}) => {
  const chart = useSelector(createWorksheetSelector!('Chart'));
  const chartMessages = useSelector(
    pipe(createWorksheetSelector!('Messages'), createMessagesGetter('Chart')),
    deepEquals
  );

  return !visible ? null : (
    <ChartFieldSection
      wide={wide}
      height={height}
      chart={chart}
      messages={chartMessages?.map((m: any) => ({ message: m.Text, severity: m.MessageType.toLowerCase() }))}
    />
  );
};

WorksheetChartSection = withInjectedProps(WorksheetChartSection);

export { WorksheetChartSection };
export default WorksheetChartSection;
